import React from "react";
import AllSerialNumbers from "./SerialNumberModule/AllSerialNumbers";

const SerialNumbers = () => {
  return (
    <div>
      <AllSerialNumbers />
    </div>
  );
};

export default SerialNumbers;
